const commonTranslation = {
  hello: "Ciao",
  welcome: "Benvenuto",
  english: "Inglese",
  german: "Tedesco",
  italian: "Italiano",
  french: "Francese",
  currentLanguage : "it-IT"
};

const loginComponent = {
  email: "E-Mail",
  emailAddress: "indirizzo e-mail",
  username: "Nome utente",
  password: "Password",
  login: "Log-in",
  signUp: "Iscriviti",
  multifactorAuthentication: "Autenticazione a più fattori",
  OTPCode: "Codice OTP",
  verifyAndProceed: "Verifica & conferma",
  resendOTP: "Invia nuovamente OTP",
  readMore: "Ulteriori informazioni",
  logout: "Disconnettersi", 
  loginOrSignup: "Log-in",
  loginWelcome: "Bentornati! Inserite i vostri dati.",
  enterEmail: "Inserisci l'e-mail",
  enterPassword: "Password",
  getStarted: "Cominciare!",
  profile: "Profilo",
  assignment_confirmation: "Conferma dell'ordine",
  revoke_confirmation:"Revoca conferma",
  verificationRequired: "Verifica richiesta",
  verificationDescription: "Inserisci il codice visualizzato nell'app di autenticazione",
  no_content : "Nessun contenuto",
  loginRemember: "Ricordati di me per 24 ore",
  ForgotPassword: "Password dimenticata", 
  NoAccount: "Non avete un account?",
  loginAppInfo: "Non ho accesso alla mia App Authenticator",
  loginSuccess: "Accesso riuscito",
  loginError: "Errore di accesso",
};

const dashboardComponent = {
  gridView: "Vista a griglia",
  tableView: "Visualizzazione tabella",
  PDFExtraction: "Pannello di controllo FNOL",
  search: "Ricerca",
  filter: "Filtro",
  filters: "Filtri",
  sortBy: "Ordina per",
  refresh: "Refresh",
  sort: "Ordinare",
  sortFields: "Campi di ordinamento",
  edit: "Modificare",
  download: "Scaricamento",
  versionHistory: "Cronologia",
  documentName: "Nome del documento",
  asc: "Ascendente",
  desc: "Discendente",
  operator: "Operatore",
  receiverName :  "Nome destinatario",
  receiver: "Ricevitore",
  extractedAt: "Estratto il",
  lastModified: "Ultima modifica",
  noOfPages: "Numero di pagine",
  status: "Stato",
  action: "Azione",
  details: "Dettagli",
  generalInformation: "Informazioni generali",
  medicine_info: "Informazioni sui medicinali",
  invoice: "Fattura",
  invoiceDate: "Data della fattura",
  invoiceReference: "Riferimento della fattura",
  vetName: "Nome del veterinario",
  vetStreet: "Via veterinaria",
  city: "Città",
  postalCode: "Codice Postale",
  language: "Lingua",
  policyholderName: "Nome dell'assicurato",
  policyholderAddress: "Indirizzo del contraente",
  treatment: "Trattamento",
  treatmentDate: "Data del trattamento",
  diagnosis: "Diagnosi",
  itemName: "Nome dell'articolo",
  quantity: "Quantità",
  prize: "Prezzo",
  VAT: "IVA",
  addTreatment: "Aggiungi il trattamento",
  addItem: "Aggiungi articolo",
  total: "Totale",
  subTotal: "Subtotale",
  calculatedSum: "Totale dopo lo sconto",
  notes: "Appunti",
  page: "Pagina",
  pages: "Pagine",
  min: "min",
  mins: " mins",
  hour: " ora",
  hours: " ore",
  day: " giorno",
  days: " giorni",
  month: " mese",
  months: " mesi",
  ago: "fa",
  modifiedBy: "Modificato da",
  modifiedAt: "Modificato il",
  clickASC: "Fare clic per ordinare in modo crescente",
  clickDESC: "Fare clic per ordinare in modo decrescente",
  petName: "Nome dell'animale",
  items: "Artikel",
  treatmentName: "Nome del trattamento",
  InvoiceTotalSumPriceWithoutVAT: "Importo totale della fattura IVA esclusa",
  InvoiceTotalSumPriceWithVAT: "Importo totale della fattura con IVA",
  CalculatedTotalSum: "Totale calcolato",
  TotalDiscountAmount: "Importo totale dello sconto",
  CalculatedTotalSumAfterDiscount: "Totale calcolato dopo lo sconto",
  recent: "Più recente",
  viewHistory: "Vedi la storia",
  remember: "Non chiedetelo più oggi",
  rememberSentance : "Oggi non vi chiederemo più un codice di verifica sul vostro dispositivo di fiducia al momento dell'accesso.",
  Complete_login : "Completa la registrazione",
  date: "Data",
  time: "Tempo",
  note: "Appunto",
  comment : "Commenti",
  revoke: "Revocare",
  deleteTreatment:"Elimina trattamento",
  deleteItem:"Elimina articolo",
  lastUpdate:"Ultimo aggiornamento",
  board:"Bacheca",
  table:"Tavolo",
  modified:"Modificato da",
  showing:"Mostrando",
  totalSum:"Somma totale",
  of: "di",
  none: "Nessuno",
  customVAT: "IVA personalizzata",
  quality_level: "Livello di Qualità",
  good: "Buono",
  verify: "Verificare",
  not_extracted: "Non Estratto",
  apply: "Applica"
};

const commonEvents = {
  add: "Aggiungere",
  update: "Aggiornare",
  save: "Salva",
  cancel: "Annulla",
  reset: "Resettare",
  download: "Scaricamento",
  clear: "Cancella",
  delete: "Eliminare",
  assign: "Assegnare",
  back: "Indietro",
  resetInitial: "Ripristina l'inizio",
  enter_notes: "Inserite qui le vostre appunti...",
  Updated : "Aggiornato",
  Exported : "Esportato",
  Revoked: "Revocato",
  Assigned: "Assegnato",
  medicineDescription: "Descrizione medica",
  purpose: "Scopo",
  usedFor: "Usato per",
  petTypes: "Tipi di animali",
  activeIngredients: "Ingredienti attivi",
  category: "Categoria",
  aiCategory: "Categoria IA",
  exclusionSubcode: "Sottocodice di esclusione",
  reasoning: "Motivazione",
  unclassified: "Non classificato",
  reasonForChange: "Motivo della modifica",
  reasonForChangePlaceholder: "Seleziona un motivo",
  changeContext: "Contesto aggiuntivo",
  changeContextPlaceholder: "Aggiungi piu dettagli sul motivo dell'aggiornamento della classificazione",
  showMore: "Mostra di piu",
  showLess: "Mostra meno",
  typeOfDamage: "Tipo di danno",
  causeOfDamage: "Causa del danno",
  loading: "Caricamento...",
  confidenceHigh: "Alta affidabilità",
  confidenceMedium: "Media affidabilità",
  confidenceLow: "Bassa affidabilità",
  feedbackReasonDiagnosis: "Diagnosi",
  feedbackReasonTreatmentContext: "Contesto del trattamento",
  feedbackReasonItemTextOrOcr: "Testo della riga o OCR",
  feedbackReasonExclusionRule: "Regola di esclusione",
  feedbackReasonInvoiceContext: "Contesto della fattura",
  feedbackReasonDuplicateOrWrongLine: "Riga duplicata o errata",
  feedbackReasonExpertJudgment: "Giudizio esperto",
  feedbackReasonOther: "Altro",
  cat_T: "Trattamento medico",
  cat_D: "Decesso / Invalidità",
  cat_QS: "Screening preventivo",
  cat_QP: "Profilassi",
  cat_C: "Terapia complementare",
  cat_V: "Vaccinazione",
  cat_Dx: "Diagnostica avanzata",
  cat_G: "Alimenti dietetici",
  cat_H: "Sedute terapeutiche",
  cat_J: "Terapia comportamentale",
  cat_W: "Ospedalizzazione",
  cat_X: "Bonus trattenuto",
  cat_S: "Servizi di soccorso",
  cat_A: "Pagamento diretto",
  cat_R: "Rapporti veterinari",
  cat_E: "Esclusione",
  exc_g: "Costi di trasporto",
  exc_x: "Spese amministrative",
  exc_z: "IVA",
  exc_p: "Esami del passaporto",
  exc_q: "Costi del microchip",
  exc_i: "Cremazione / Incenerimento",
  exc_b: "Ferratura cavalli",
  exc_s: "Sterilizzazione elettiva",
  exc_c: "Costi di pensione",
  exc_m: "Cure non mediche",
  exc_d: "Esclusione cure dentali",
  exc_r: "Costi rapporti veterinari"
};

const documentStatus = {
  not_yet_started: "Non iniziato",
  in_progress: "In corso",
  completed: "Completato",
};

const confirmationMessage = {
  deleteConfirmationTitle: "Conferma",
  deleteActionTreatmentContent:
    "Siete sicuri di voler cancellare questo trattamento? Questa azione non può essere annullata",
  deleteActionItemContent:
    "Sei sicuro di voler eliminare questo elemento? Questa azione non può essere annullata",
  resetConfirmationTitle: "Conferma",
  resetToInitialConfirmationTitle: "Ripristino della conferma iniziale",
  resetActionContent:
    "Siete sicuri di voler eseguire un reset? Questa azione non può essere annullata",
  resetInitialActionContent:
    "Siete sicuri di voler ripristinare lo stato iniziale? Questa azione non può essere annullata",
  assignmentConfirmation:
    "È sicuro di voler assegnare questo documento a se stesso?",
  revokeConfirmation: "È sicuro di voler annullare l'assegnazione di questo documento alla sua persona?",
  reAssignConfirmation:
    "È sicuro di voler riassegnare questo documento a se stesso?",
  assignedTo: "Questo documento è assegnato a",
};

const errorNotification = {
  invalidEmail: "Inserisci un indirizzo e-mail valido!",
  emailEmpty: "Inserite il vostro indirizzo e-mail!",
  passwordEmpty: "Inserisci la password!",
  notAllowedToEdit: "Questo documento non deve essere modificato",
  noteNotSaved: "Note non salvate",
  tokenExpired: "La sessione è scaduta, accedi di nuovo",
  accessDenied: "Accesso negato",
  notAssigned: "Assegnare il documento per accedere",
};

const successNotification = {
  DocumentResetToInitial : 'Reset iniziale riuscito',
  UpdateSuccess: "Aggiornato con successo",
  noteSaved: "Note salvate correttamente",
  successDocumentProgressStatus: "Assegnazione riuscita",
  revokeDocument: "Assegnazione revocata",
};

export const itJSON = {
  ...commonEvents,
  ...loginComponent,
  ...dashboardComponent,
  ...errorNotification,
  ...commonTranslation,
  ...documentStatus,
  ...confirmationMessage,
  ...successNotification
};
